import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getMunicipalitiesByStates = async ({ commit }, stateId) => {
  commit('setMunicipalityIsLoading', true);
  let url = `/municipalities/selectable/${stateId}`;

  await connection.get(url)
    .then(res => {
      const municipalities = res.data.data;
      commit('setMunicipalitiesSelectable', municipalities);
      commit('setMunicipalityIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setMunicipalityIsLoading', false);
    });
}

export const loadMunicipalities = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setMunicipalityIsLoading', true);
    let url = `/municipalities`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        console.log(res);
        const municipalities = res.data.data;
        commit('setMunicipalities', municipalities);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setMunicipalitiesPaginated', res.data);
        commit('setMunicipalityIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setMunicipalityIsLoading', false);
      });
}

export const municipalityById = async ({ commit }, id) => {
  commit('setMunicipalityIsLoading', true);
  await connection.get(`/municipalities/${id}`)
    .then(res => {
      commit('setMunicipalityDetail', res.data.data);
      commit('setMunicipalityIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setMunicipalityIsLoading', false);
    });
}

export const storeMunicipality = async ({ commit }, municipality) => {
  console.log(municipality);
  commit('setMunicipalityIsCreating', true);
  await connection.post(`/municipalities/create`, municipality)
    .then(res => {
      console.log(res.data);
      commit('saveNewMunicipalities', res.data);
      commit('setMunicipalityIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setMunicipalityIsCreating', false);
    });
}

export const updateMunicipality = async ({ commit }, municipality ) => {
  commit('setMunicipalityIsUpdating', true);
  await connection.put(`/municipalities/${municipality.id}/update`, municipality)
    .then(res => {
      commit('saveUpdatedMunicipality', res.data);
      commit('setMunicipalityIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setMunicipalityIsUpdating', false);
    });
}

export const deleteMunicipality = async ({ commit }, municipality) => {
  commit('setMunicipalityIsDeleting', true);
  await connection.delete(`/municipalities/${municipality.id}/delete`)
    .then(res => {
      commit('setDeleteMunicipality', res.data);
      commit('setMunicipalityIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setMunicipalityIsDeleting', false);
    });
}
